window.onload = function () {
  updateBBContent();
};

function openModalBB() {
  document.querySelector(".popup").style.display = "flex";
  document.querySelector(".popup").style.opacity = 1;
  document.querySelector(".popup-dialog").style.opacity = 1;
  removeClassIfWide();
  console.log("clicked");
}

function closeModalBB() {
  document.querySelector(".BB-modal").style.display = "none";
}

function removeClassIfWide() {
  const stickyElement = document.querySelector(".product-right-content-sticky");
  const featured = document.querySelector(".fc-bb");
  const related_product = document.querySelector(".rp-bb");

  if (stickyElement && window.innerWidth > 1024) {
    stickyElement.classList.remove("d-xl-block");
  }

  if (featured) {
    featured.style.display = "none";
    console.log(">>>>>>>>>>>>>featured");
  }

  if (related_product) {
    related_product.style.display = "none";
    console.log(">>>>>>>>>>>>>related_product");
  }
}

function addClassIfWide() {
  const stickyElement = document.querySelector(".product-right-content-sticky");
  const featured = document.querySelector(".fc-bb");
  const related_product = document.querySelector(".rp-bb");
  if (stickyElement && window.innerWidth > 1024) {
    // Use setTimeout to add class after 2 seconds (2000ms)
    setTimeout(function () {
      stickyElement.classList.add("d-xl-block");
    }, 1000);
  }
  if (featured) {
    setTimeout(function () {
      featured.style.display = "block";
    }, 1000);
  }
  if (related_product) {
    setTimeout(function () {
      related_product.style.display = "block";
    }, 1000);
  }
}

const closeButton = document.querySelector(".BB-modal .popup-close");
if (closeButton) {
  closeButton.addEventListener("click", addClassIfWide);
}

function setupPriceObserver() {
  var targetNode = document.querySelector(".price-item");

  if (!targetNode) return;

  var observerCallback = function (mutationsList, observer) {
    for (var mutation of mutationsList) {
      if (mutation.type === "childList" || mutation.type === "characterData") {
        updateBBContent();

        break;
      }
    }
  };

  var observer = new MutationObserver(observerCallback);

  var config = { subtree: true, childList: true, characterData: true };

  observer.observe(targetNode, config);

  updateBBContent();
}

document.addEventListener("DOMContentLoaded", function () {
  setupPriceObserver();
});

function updateBBContent() {
  var element = document.querySelector(".price-item");

  if (element) {
    var content = element.textContent;
    var numericString = content.replace("₹ ", "").replace(",", "");

    var originalAmount = parseFloat(numericString);

    // var numToAdd = parseInt(originalAmount * 0.5);
    var numToAdd = parseInt(
      originalAmount * (Math.max(100 - 90 * 0.14, 50) / 100)
    );
    var numToAdd2 = parseInt(
      originalAmount * (Math.max(100 - 180 * 0.14, 50) / 100)
    );
    var targetDiv = document.querySelector(".buy-b-price");
    var targetDiv2 = document.querySelector(".buy-b-price-2");

    if (targetDiv) {
      targetDiv.innerHTML = numToAdd;
    }
    if (targetDiv2) {
      targetDiv2.innerHTML = numToAdd2;
    }
  }
}
const basePrice = 10000; // Base buyback price
const priceSpan = document.querySelector(".buy-b-price-2");
const selectedYearSpan = document.getElementById("selectedYear");

function updatePriceBB2(months) {
  selectedYearSpan.textContent = months;

  var element = document.querySelector(".price-item");
  const days = months * 30;
  if (element) {
    var content = element.textContent;
    var numericString = content.replace("₹ ", "").replace(",", "");

    var originalAmount = parseFloat(numericString);

    if (months == 6 || months == 12) {
      let dynamicPercentage = 100 - days * 0.14;
      dynamicPercentage = Math.max(dynamicPercentage, 50);
      var numToAdd = parseInt(originalAmount * (dynamicPercentage / 100));
      priceSpan.textContent = numToAdd;
    } else if (months == 18 || months == 24) {
      let dynamicPercentage = (days - 365) * (10 / 365);
      dynamicPercentage = Math.max(30 - dynamicPercentage, 20);
      var numToAdd = parseInt(originalAmount * (dynamicPercentage / 100));
      priceSpan.textContent = numToAdd;
    } else if (months == 30 || months == 36) {
      let dynamicPercentage = (days - 730) * (20 / 365);
      dynamicPercentage = Math.max(20 - dynamicPercentage, 0);
      var numToAdd = parseInt(originalAmount * (dynamicPercentage / 100));
      priceSpan.textContent = numToAdd;
    }
  }
  // const newPrice = basePrice + (year * 2000); // Add 2000 for each additional year
  // priceSpan.textContent = newPrice;
}

// Set the initial price for the default value
updatePriceBB2(6);

const BB_popup = document.getElementById("bb");

BB_popup.addEventListener("click", function (event) {
  // addClassIfWide();
  if (!BB_popup.contains(event.target)) {
    addClassIfWide();
    console.log("clicked ppup>>>>>>>>>>>>>>>>");
  }
});
